import type { FieldName, SetFieldValue, UseFormMethods } from 'react-hook-form';

import type { NewObject } from 'types';

export function setFormValues<T extends NewObject>(setValue: UseFormMethods<T>['setValue'], data: T): void {
  Object.entries(data).forEach(([name, value]) => setValue(name as FieldName<T>, value as SetFieldValue<T>));
}
